import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/account-statuses'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'account_statuses',
          component: Index,
          meta: { permissions: ['settings.availability_statuses_manage'] },
        },
      ],
    },
  ],
};
